import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { SchedulingEditActions } from "store/ducks/transports";

export function* schedulingEditRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/scheduling-edit/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(SchedulingEditActions.success(data));
    notify("success", "Agendamento alterado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(SchedulingEditActions.failure(errorMessage));
  }
}
